import { lazyLoadView } from '@utils/LazyLoad'
import { FEATURES, MODAL, SEARCH_GROUPS } from '@constants/Text'

export default [
  {
    path: '/profissionais/gerenciar',
    name: 'professionals',
    meta: {
      can_show: FEATURES.PROFESSIONALS,
      search: {
        title: 'Profissionais',
        description: 'Gestão da equipe, cadastros e acessos dos profissionais',
        keywords: ['equipe', 'assessores', 'time', 'acessos', 'cadastro'],
        icon: 'people-profile',
        group: SEARCH_GROUPS.GESTAO_PESSOAS,
        actions: [
          {
            id: 'cadastrar-profissional',
            title: 'Cadastrar profissional',
            keywords: ['novo profissional', 'criar assessor', 'adicionar'],
            modal: MODAL.NEW_PROFESSIONAL,
          },
        ],
      },
    },
    component: () =>
      lazyLoadView(
        import('@modules/professionals/views/view-manage-professionals')
      ),
  },
  {
    path: '/professionais/permissoes',
    name: 'professionals.permissions',
    meta: {
      can_show: FEATURES.PROFESSIONALS,
      search: {
        title: 'Grupos de permissões',
        description: 'Configurar grupos e níveis de acesso da equipe',
        keywords: ['permissões', 'acessos', 'grupos', 'perfis', 'roles'],
        group: SEARCH_GROUPS.GESTAO_PESSOAS,
      },
    },
    params: {
      role: '',
    },
    component: () =>
      lazyLoadView(
        import('@modules/professionals/views/view-setting-permissions-groups')
      ),
  },
  {
    path: '/profissionais/:id_profissional',
    name: 'professionals.individual',
    // meta: {
    //   can_show: FEATURES.MANAGE_PROFESSIONALS,
    // },
    redirect: (to) => {
      const { id_profissional, return_url } = to.params

      return {
        name: 'professionals.individual.personal_data',
        params: {
          id_profissional,
          ...(return_url ? { return_url } : {}),
        },
      }
    },
    component: () =>
      lazyLoadView(
        import('@modules/professionals/views/professionals-nav-bar.vue')
      ),
    children: [
      {
        path: 'dados_pessoais/:return_url?',
        name: 'professionals.individual.personal_data',
        // meta: {
        //   can_show: FEATURES.MANAGE_PROFESSIONALS,
        // },
        component: () =>
          lazyLoadView(
            import(
              '@modules/professionals/views/view-professional-personal-data'
            )
          ),
      },
      {
        path: 'dados_bancarios',
        name: 'professionals.individual.bank_details',
        meta: {
          can_show: FEATURES.COMISSOES,
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/professionals/views/view-professional-bank-details.vue'
            )
          ),
      },
      {
        path: 'partnership',
        name: 'professionals.individual.partnership',
        // meta: {
        //   can_show: FEATURES.MANAGE_PROFESSIONALS,
        // },
        component: () =>
          lazyLoadView(
            import(
              '@modules/professionals/views/view-professional-partnership.vue'
            )
          ),
      },

      {
        path: 'contratos',
        name: 'professionals.individual.contracts',
        // meta: {
        //   can_show: FEATURES.MANAGE_PROFESSIONALS,
        // },
        component: () =>
          lazyLoadView(
            import(
              '@modules/professionals/views/view-professional-contracts.vue'
            )
          ),
      },

      {
        path: 'clientes',
        name: 'professionals.individual.clients',
        // meta: {
        //   can_show: FEATURES.MANAGE_PROFESSIONALS,
        // },
        component: () =>
          lazyLoadView(
            import('@modules/professionals/views/view-professional-clients.vue')
          ),
      },
      {
        path: 'permissao',
        name: 'professionals.individual.permissions',
        // meta: {
        //   can_show: FEATURES.MANAGE_PROFESSIONALS,
        // },
        component: () =>
          lazyLoadView(
            import(
              '@modules/professionals/views/view-professional-permissions.vue'
            )
          ),
      },
      {
        path: 'churn',
        name: 'professionals.individual.churn',
        // meta: {
        //   can_show: FEATURES.MANAGE_PROFESSIONALS,
        // },
        component: () =>
          lazyLoadView(
            import('@modules/professionals/views/churn/view-churn.vue')
          ),
      },
      {
        path: 'metas',
        name: 'professionals.individual.goals',
        // meta: {
        //   can_show: FEATURES.GOALS,
        // },
        component: () =>
          lazyLoadView(
            import('@modules/professionals/views/goals/view-goals.vue')
          ),
      },
    ],
  },
]
